import * as React from 'react'
import { SVGProps } from 'react'

const LPTUSD = (props: SVGProps<SVGSVGElement>) => (
  <svg width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <rect x='0.5' y='0.5' width='47' height='47' rx='23.5' fill='white' />
    <g clipPath='url(#clip0_1712_18737)'>
      <path d='M33.7941 21.9118V26.5882H38.4706V21.9118H33.7941Z' fill='black' />
      <path d='M23.6618 16.4558V21.1322H28.3382V16.4558H23.6618Z' fill='black' />
      <path d='M23.6618 27.3675V32.044H28.3382V27.3675H23.6618Z' fill='black' />
      <path d='M13.5294 32.8235V37.5H18.2059V32.8235H13.5294Z' fill='black' />
      <path d='M13.5294 21.9118V26.5882H18.2059V21.9118H13.5294Z' fill='black' />
      <path d='M13.5294 11V15.6765H18.2059V11H13.5294Z' fill='black' />
    </g>
    <rect x='0.5' y='0.5' width='47' height='47' rx='23.5' stroke='#D1D3E5' />
    <defs>
      <clipPath id='clip0_1712_18737'>
        <rect width='24.9412' height='26.5' fill='white' transform='translate(13.5294 11)' />
      </clipPath>
    </defs>
  </svg>
)

export default LPTUSD
